import React from 'react'
import Typography from "@material-ui/core/Typography"
import styles from './styles'
import {stepsContent} from "~/containers/expertise/steps/stepsContent"
import { useMediaQuery, useTheme } from "@material-ui/core"

export const Steps = () => {
    const classes = styles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    return (
      <div className={classes.stepsContainer}>
        <Typography variant={isMobile ? 'subtitle1' : 'h4'} className={classes.stepsTitle}>Get your patient started with Orthosnap within two weeks!</Typography>
        <Typography variant="body1" className={classes.stepsSubTitle}>We guarantee a 14 day turnaround from the moment
          we receive your patient’s dental impressions.</Typography>
        {stepsContent.map(({icon, key, stepNum, stepResult, stepText}) =>
          (<StepItem key={key} icon={icon} stepResult={stepResult} stepText={stepText} num={stepNum}/>))}
      </div>
    )
};


interface ItemProps {
  num: string;
  icon: any,
  stepText: string;
  stepResult: string | React.ReactNode
}
function StepItem({icon, num, stepText, stepResult}: ItemProps) {
  const classes = styles();
  return (<>
    <div className={classes.itemContainer}>
        <div className={classes.itemHeader}>
            <Typography className={classes.itemNum} variant="h3" component="h2">{num}</Typography>
            <Typography className={classes.itemStepResult} variant="h6" component="h5">{stepResult}</Typography>
        </div>
        <div className={classes.itemContent}>
            {icon}
            <Typography className={classes.itemText} variant="body1">{stepText}</Typography>
        </div>
    </div>
  </>)
}
